<template>
    <div id="boxPrint" class="row">
        <div class="col-md-12">
            <h1 class="h4 mb-3 text-gray-800 text-center">
                {{ $t("PARTICIPAÇÃO EM PROGRAMA SOCIAL") }}
            </h1>
        </div>
        <load v-if="loading" />
        <div v-else class="col-md-12">
            <print-header></print-header>
            <table
                class="table table-bordered b-table b-table-stacked-md bg-white"
            >
                <tbody>
                    <tr>
                        <td>
                            ID: <strong>{{ item.id }}</strong>
                        </td>
                        <td>
                            CÓDIGO FAMILIAR:
                            <strong>{{
                                item.familia.codigo_familiar
                                    ? item.familia.codigo_familiar
                                    : item.familia.id
                            }}</strong>
                        </td>
                        <td>
                            CADASTRADO: <strong>{{ item.cadastrado }}</strong>
                        </td>
                        <td>
                            STATUS:
                            <b v-html="item.status_nome"></b>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4">
                            TÉCNICO AUTOR: 
                            <b>{{ item.autor }}</b>
                        </td>
                    </tr>
                    <tr>
                        <td v-if="item.familia.familiares" colspan="4">
                            BENEFICIÁRIO(S):
                            <strong
                                class="mr-2"
                                v-for="(pessoa, index) in pessoas"
                                :key="pessoa.id"
                            >
                                <span v-html="pessoa.value"></span>
                                <span v-if="pessoa.nis">
                                    - NIS: {{ pessoa.nis }}</span
                                >
                                <span v-if="index < item.pessoas.length - 1"
                                    >,</span
                                >
                            </strong>
                        </td>
                    </tr>
                    <tr v-if="item.programa">
                        <td colspan="3">
                            PROGRAMA:
                            <b>{{ item.programa.nome }}</b>
                            <span v-if="item.programa.valor">
                                VALOR DO PROGRAMA:
                                <b>{{ item.programa.valor }} </b>
                            </span>
                        </td>
                        <td>
                            VALOR PAGO:
                            <b>R$ {{ item.valor }}</b>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4">
                            OBSERVAÇÕES:<br />
                            <span v-html="item.descricao"></span>
                        </td>
                    </tr>

                    <tr>
                        <td colspan="2" class="text-center">
                            <br />
                            <hr />
                            <span v-if="item.user">
                                <b>{{ item.user.name }}</b>
                            </span>
                            <br />
                            Técnico de Referência
                        </td>
                        <td colspan="2" class="text-center">
                            <br />
                            <hr />
                            <span v-if="item.pessoa">
                                <b>{{ item.pessoa.nome_completo }}</b>
                                <br />
                                Beneficiário
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <print-footer 
                v-if=" item.user.tecnico.assinatura_digital" 
                :tecnico="item.user.tecnico" 
                class="mt-0" 
                :assinatura=" item.user.tecnico.assinatura_digital"
                :wpp="wpp"
                :email="email"
            />
            
            <p class="text-muted">{{ app_cidade }}, {{ app_data_atual }}</p>

            <div class="row pt-4 px-0 d-flex justify-content-end no-print">
                <div class="col-auto px-2 text-right">
                    <form-toggle
                        grid="12"
                        mt="0"
                        v-model="email"
                        label="Email"
                    />
                    <form-toggle
                        grid="12"
                        mt="0"
                        v-model="wpp"
                        label="Telefone/WhatsApp"
                    />
                    <router-link
                        :to="`/dashboard/programassociais/concessao/${item.id}/edit`"
                        class="btn btn-default"
                    >
                        <i class="mdi mdi-arrow-left" />
                    </router-link>

                    <a class="btn btn-sm py-1 btn-primary" @click="print()">
                        <i class="mdi mdi-printer mdi-18px" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            app_cidade: this.$store.state.settings.app_cidade,
            app_data_atual: this.$store.state.settings.app_data_atual,
            item: {},
            wpp: true,
            email: true
        };
    },
    computed: {
        pessoas() {
            const pessoas = this.item.pessoas_objetos ?? [];

            const map = pessoas.map((elem) => ({
                id: elem.id,
                value:
                    elem.posicao_familiar == 1
                        ? "<b>RF - </b> " +
                          elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>"
                        : elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>",
                nis: elem.documento.nis,
            }));
            return map;
        },
    },
    mounted() {
        this.getItem();
    },
    methods: {
        getItem() {
            this.loading = true;
            axios
                .get(
                    `api/dashboard/programasocial/beneficiarios/` +
                        this.$route.params.id
                )
                .then((response) => {
                    this.item = response.data.data;
                })
                .finally(() => (this.loading = false));
        },
        print() {
            const modal = document.getElementById("boxPrint");
            const cloned = modal.cloneNode(true);
            let section = document.getElementById("print");

            if (!section) {
                section = document.createElement("div");
                section.id = "print";
                document.body.appendChild(section);
            }

            section.innerHTML = "";
            section.appendChild(cloned);
            window.print();
        },
    },
};
</script>

<style>
@media screen {
    #print {
        display: none;
    }
}

@media print {
    body * {
        visibility: hidden;
    }
    #print,
    #print * {
        visibility: visible;
    }
    #print {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
}
</style>
